export default __webpack_public_path__ + "static/media/dollar.cd16b729.jpg";